import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './layout_blank.component.html',
    styleUrls: ['./layout_blank.component.scss']
})
export class LayoutBlankComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
